window.addEventListener("DOMContentLoaded", () => {
  const richtextNutrition = document.querySelector(".richtext--nutrition");

  if (richtextNutrition) {
    const headings = richtextNutrition.querySelectorAll("h3");

    headings.forEach((heading, index) => {
      const nextP = heading.nextElementSibling;

      if (nextP && nextP.tagName === "P") {
        // Create a new div with class .nutrition-column
        const nutritionColumn = document.createElement("div");
        nutritionColumn.classList.add("nutrition-column");

        // Move the <h3> and <p> into the new div
        nutritionColumn.appendChild(heading);
        nutritionColumn.appendChild(nextP);

        // Insert the new div into the DOM
        richtextNutrition.insertBefore(
          nutritionColumn,
          nextP.nextSibling || null
        );

        // Add a separator after each .nutrition-column except the last one
        if (index < headings.length - 1) {
          // Check if it's not the last h3
          const separator = document.createElement("div");
          separator.classList.add("nutrition--separator");

          // Insert the separator after the current .nutrition-column
          richtextNutrition.insertBefore(
            separator,
            nutritionColumn.nextSibling || null
          );
        }
      }
    });
  }
});

// ------------------ hide accordions when not used ------------------ //

document.addEventListener("DOMContentLoaded", function () {
  let richtextPreparation = document.querySelector(
    ".richtext--preparation.w-richtext"
  );
  let richtextPreparationIsEmpty =
    !richtextPreparation || richtextPreparation.innerHTML.trim() === "";

  // Hide empty .template--text-item elements
  document.querySelectorAll(".template--text-item").forEach((accordion) => {
    let richText = accordion.querySelector(".w-richtext");
    if (richText && richText.innerHTML.trim() === "") {
      accordion.style.display = "none"; // Hide empty .template--text-item
    }
  });

  // Show or hide standalone .w-richtext elements based on .richtext--preparation.w-richtext content
  document.querySelectorAll(".w-richtext").forEach((richtext) => {
    let isInsideTemplateItem =
      richtext.closest(".template--text-item") !== null;

    if (!isInsideTemplateItem) {
      richtext.style.display = richtextPreparationIsEmpty ? "block" : "none";
    }
  });
});

// ------------------ convert youtube to embed ------------------ //

document.addEventListener("DOMContentLoaded", function () {
  const videoWrapper = document.querySelector(".template--video-wrapper");

  if (!videoWrapper) return; // Ensure the element exists

  // Get the YouTube URL from the text inside the div
  const youtubeURL = videoWrapper.textContent.trim();
  if (!youtubeURL.startsWith("https://www.youtube.com/watch?v=")) return; // Validate URL format

  // Extract video ID
  const videoID = youtubeURL.split("v=")[1]?.split("&")[0];
  if (!videoID) return; // Prevent errors if the URL is incorrect

  const embedURL = `https://www.youtube.com/embed/${videoID}`;

  // Create iframe
  const iframe = document.createElement("iframe");
  iframe.src = embedURL;
  iframe.setAttribute("frameborder", "0");
  iframe.setAttribute("allowfullscreen", "");

  // Apply styles
  iframe.style.width = "100%";
  iframe.style.height = "100%";

  // Replace the text with the embedded video
  videoWrapper.innerHTML = ""; // Clear existing text content
  videoWrapper.appendChild(iframe);
});
